module.exports = __webpack_public_path__ + "static/media/s_27.167431f3.mp3";